export const OfferStatusEnum = {
  Valid: 'valid',
  Selected: 'selected',
  Error: 'error',
}
export type OfferStatusEnum = typeof OfferStatusEnum[keyof typeof OfferStatusEnum]